export default __webpack_public_path__ + "static/media/sun-source-bg.3543c66b.jpeg";